import fetchAPI from '../fetchAPI';

export const callDeleteBill = async (id: string): Promise<iResponse<{ id: string }>> => {
  const response: iResponse<{ id: string }> = await fetchAPI({
    method: `DELETE`,
    route: `bills/${id}`
  });
  return response;
};

export default callDeleteBill;
